import { styled } from "styled-components";
import { masterType } from "../../../configs/config";
import { InputWrapper } from "../../../pages/onboarding/AboutYouConnectWith.page";
import { Column, Gap, Row } from "../../../styles/Utils";

interface MasterTypesInputProps {
  who: string;
  value: string[]; // Controlled value from react-hook-form
  onChange: (value: string[]) => void; // Function to update value
}

export function MasterTypesInput({ who, value, onChange }: MasterTypesInputProps) {
  const handleTraitClick = (trait: string) => {
    const next = value.includes(trait) ? value.filter((t) => t !== trait) : [...value, trait];

    onChange(next);
  };
  return (
    <InputWrapper>
      <Column $alignItem="flex-start">
        <span>{who}:</span>
        <Gap $height={1} />
        <Row $gap={0.3} $justifyContent="space-evenly" $alignItem="center" $flexWrap="wrap">
          {masterType.map((e) => (
            <Chip
              key={e}
              $selected={value.includes(e)}
              // $selected={selectedTraits.includes(e)}
              onClick={() => handleTraitClick(e)}
            >
              {e}
            </Chip>
          ))}
        </Row>
      </Column>
    </InputWrapper>
  );
}

const Chip = styled.div<{
  $selected: boolean;
}>`
  border: ${(props) => (props.$selected ? "1.5rem" : `3px solid ${props.theme.color.tertiaryLight}`)};
  padding-inline: 1rem;
  padding-block: ${(props) => (props.$selected ? "1.5rem" : "1rem")};
  font-family: ${(props) => props.theme.font.family.main};
  background-color: ${(props) => (props.$selected ? props.theme.color.tertiary : props.theme.color.primary)};
  color: ${(props) => props.theme.color.tertiaryLight};
  font-size: ${(props) => (props.$selected ? props.theme.font.size.title.medium : props.theme.font.size.title.small)};
  border-radius: 100px;
`;
